import { buildKarteNativeUserRealtimePath, KARTE_QANT_ENTRY_PATH } from '../config/const/karte.js';
import type { KarteProductKey } from '../contract/index.js';
import type { HrefBuilder } from './urls.js';

/**
 * QANT ホストから KARTE-only 行へ切替えるときの遷移先。
 *
 * - `karteEnabledProducts` が空配列 → KARTE 本体（ユーザーリアルタイム）
 * - 1 件以上 / 未取得（undefined）→ QANT プロダクト入口（`/rightsupport/`）
 *   undefined は KARTE V2 が field 未実装のロールアウト窓向けフォールバック。
 */
export function resolveKarteOnlyProjectSwitchHref(params: {
  buildHref: HrefBuilder;
  karteProjectId: string;
  karteEnabledProducts?: readonly KarteProductKey[];
}): { href: string; newTab: true } {
  const { buildHref, karteProjectId, karteEnabledProducts } = params;
  const useNativeEntry = karteEnabledProducts !== undefined && karteEnabledProducts.length === 0;

  if (useNativeEntry) {
    const { href } = buildHref({
      host: 'karte-io',
      path: buildKarteNativeUserRealtimePath(karteProjectId),
      skipProjectParam: true,
    });
    const url = new URL(href);
    url.searchParams.set('type', 'realtime');
    return { href: url.toString(), newTab: true };
  }

  // skipProjectParam: このリンクの project は「対象行の project」であり、
  // buildHref が自動付与する現在の projectIds ベースの project とは異なる。
  const { href } = buildHref({ host: 'karte-io', path: KARTE_QANT_ENTRY_PATH, skipProjectParam: true });
  const url = new URL(href);
  url.searchParams.set('project', karteProjectId);
  return { href: url.toString(), newTab: true };
}
